// extracted by mini-css-extract-plugin
export var wrapper = "BackToTop-module--wrapper--3uwyJ";
export var arrowWrapper = "BackToTop-module--arrowWrapper--3lbVj";
export var copyrightWrapper = "BackToTop-module--copyrightWrapper--31kWI";
export var stampWrapper = "BackToTop-module--stampWrapper--Pi5Hu";
export var copyright = "BackToTop-module--copyright--3DYwc";
export var arrow = "BackToTop-module--arrow--21_HY";